import { render, staticRenderFns } from "./zhiliaoxinxi.vue?vue&type=template&id=3d04aec4&scoped=true&"
import script from "./zhiliaoxinxi.vue?vue&type=script&lang=js&"
export * from "./zhiliaoxinxi.vue?vue&type=script&lang=js&"
import style0 from "./zhiliaoxinxi.vue?vue&type=style&index=0&id=3d04aec4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d04aec4",
  null
  
)

export default component.exports